module.exports = __webpack_public_path__ + "assets/images/project/constituencies/jalan-besar-grc.jpg?v=d3e5ea68";